import { FileText, FileSpreadsheet, FileImage, FileArchive, File as FileIcon } from "lucide-react";

export const fmtBytes = (n) => {
  if (!n && n !== 0) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} kB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("nl-NL", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export function FileTypeIcon({ filename, className = "w-5 h-5" }) {
  const ext = (filename || "").split(".").pop().toLowerCase();
  if (["xlsx", "xlsm", "xls", "csv"].includes(ext)) return <FileSpreadsheet className={`${className} text-positive`} />;
  if (["png", "jpg", "jpeg"].includes(ext)) return <FileImage className={`${className} text-primary`} />;
  if (ext === "zip") return <FileArchive className={`${className} text-muted-foreground`} />;
  if (["pdf", "docx", "doc", "txt", "md"].includes(ext)) return <FileText className={`${className} ${ext === "pdf" ? "text-accent" : "text-foreground"}`} />;
  return <FileIcon className={className} />;
}
